<template>
  <div class="text-center pd24">
    <div class="text-999">与供销商合作后，可将供销商商品导入到您的分销商品库，方便销售和铺货</div>
    <p class="text-333">复制链接或下载海报发给想合作的商家，所有人可访问，链接有效期默认90天</p>
    <div class="poster-content" id="poster">
      <div class="flex space-between">
        <div class="text-left">
          <img
            crossOrigin="anonymous"
            width="72px"
            src="https://img.alicdn.com/imgextra/i3/2211227103034/O1CN01RSp9CI1YHcRMmx1d5_!!2211227103034.png"
            alt=""
          />
          <div class="ftsz20 mgt16 text-bold text-333">
            {{userInfo.companyName}}
          </div>
          <div class="text-grayer mgt16">
            诚邀您供货合作
          </div>
        </div>
        <div class="pd4" style="background: #fff; border-radius: 4px;">
          <img
            style="width: 94px; height: 94px;"
            :src="`https://scm.superboss.cc/api/wx/unAuth/proxy.json?pic=${wxCodeUrl}`"
          />
        </div>
      </div>
      <div class="mgt24 major-platform">
        <div style="color: #E58D58;" class="mgb12">
          — 销售渠道 —
        </div>
        <div>
          <span v-if="!detail.showSupplier">{{ platformUnseeText }}</span>
          <span v-else-if="detail.majorPlatform.length">
            <img
              class="avatar"
              style="margin-right:10px"
              v-for="source in detail.majorPlatform"
              :key="source.k"
              :src="PLATFORM_ICONS_MAP[source.k]"
              crossOrigin="anonymous"
            />
          </span>
          <span v-else> 暂无 </span>
        </div>
      </div>
    </div>
    <div class="flex justify-content-center mgt16">
      <el-button
        type="primary"
        @click="sendLog"
        v-clipboard:copy="form.link"
        v-clipboard:success="() => $message.success('复制成功')"
      >
        复制邀请链接
      </el-button>
      <el-button
        type="primary"
        @click="downloadPoster"
      >
        下载邀请海报
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from "lodash";
import { distributorInviteCompanyInfo, generateQrCodeUrl } from '@/api/distributor';
import supplier_dictionary from "@/dictionary/supplier";
import { PLATFORM_ICONS_MAP } from '@/dictionary/platforms.js';
import html2canvas from 'html2canvas'
import { disInviteSupplierUrl } from '@/api/supplier';
import { addStatisticsLog } from '@api/base';

export default {
  props: {
    role: {
      type: String,
      default: 'distributor',
    }
  },
  components: {
  },
  data() {
    return {
      PLATFORM_ICONS_MAP,
      wxCodeUrl: '',
      detail: {
        majorPlatform: [],
      },
      form: {
        link: `${window.location.origin}/supplier/management/mine?`,
      },
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
    ]),
    platformUnseeText() {
      return supplier_dictionary.PLATFORM_UNSEE_TEXT;
    },
  },
  mounted() {
    this.getWxCodeUrl();
    this.getSupplierInfo();
    this.handleGetDmsCompanyInfo();
  },
  methods: {
    async getWxCodeUrl() {
      let res = await generateQrCodeUrl({
        path: 'pages/index/index',
        params: JSON.stringify({
          distributorCompanyId: this.userInfo.companyId,
          fromLoginIdentity: 2,
          invitation: 2,
        }),
        envVersion: 'release', // release -正式版 trial - 体验版 develop-开发版
        width: 144,
        // isHyaline: true,
      })
      let url = get(res, 'data', '');
      this.wxCodeUrl = url;
    },

    async getSupplierInfo() {
      const { companyId } = this.userInfo;
      let res = await distributorInviteCompanyInfo({
        distributionCompanyId: companyId
      });
      let detail = get(res, 'data', {}) || {};
      detail.majorPlatform = JSON.parse(detail.majorPlatform);
      this.detail = detail;
    },

    async handleGetDmsCompanyInfo() {
      try {
        const res = await disInviteSupplierUrl();
        this.form = {
          link: res.data,
        };
        
        // const { companyId, needAudit, companyName } = res.data;
        // // needAudit写死为0，分销商邀请供销商不需要审核
        // this.form = {
        //   link: `${window.location.origin}/supplier/management/mine?inviteId=${companyId}&needAudit=0&companyName=${companyName}\n诚邀你供货合作`,
        // };
      } catch (error) {
        console.log("error: ", error);
      }
    },

    sendLog(){
      addStatisticsLog({type:'invite',platformType:'pc',
        companyId:this.userInfo.companyId,
        companyName:this.userInfo.companyName,
        loginIdentity:2
      })
    },

    downloadPoster() {
      let container = document.getElementById('poster');
      html2canvas(container, {
        width: container.clientWidth,
        height: container.clientHeight,
        useCORS: true,
      }).then(canvas => {
        let src = canvas.toDataURL('image/jpg', 1);
        let image = new Image()
        image.src = src
        let url = image.src.replace(/^data:image\/[^;]/, 'data:application/octet-stream')
        let a = document.createElement('a')
        a.download = `${this.userInfo.companyName}诚邀您供货合作.jpg` // 设置下载的文件名，默认是'下载'
        a.href = url
        document.body.appendChild(a)
        a.click()
        a.remove() // 下载之后把创建的元素删除
      });
      this.sendLog();
    },

  }
}

</script>

<style lang='scss' scoped>
.poster-content {
  background: linear-gradient(315deg, #ffa673 15%, #fee4d3 98%);
  padding: 32px;
}
.major-platform {
  background: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  border: 0.5px dashed #2695FA;
  padding: 24px;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
</style>
